<template>
  <div class="video-call" @mousemove="controlsDisplay()">
    <div v-show="connecting" class="connecting">
      <div v-if="!loading" class="userInfo">
        <v-gravatar
          style="min-width: 30px"
          width="200"
          :email="otherUser.email"
          v-if="!otherUser.avatarUrl"
        />
        <img v-else :src="otherUser.avatarUrl" />
        <p class="white--text text-center mt-2 mb-2 fs-xxxlarge">
          {{ otherUser.userName }}
        </p>
        <div
          v-if="userWaiting"
          class="d-flex flex-row mx-auto"
          style="width: fit-content"
        >
          <p class="white--text text-center fs-medium">در انتظار</p>
        </div>
        <div v-else class="mx-auto">
          <p class="white--text fs-medium">
            آماده ورود به جلسه. برای پیوستن کلیک کنید:
          </p>
          <v-btn class="blue-borderedBtn fs-small" @click="join()">
            پیوستن به جلسه</v-btn
          >
        </div>
      </div>

      <!-- Video call control buttons and call time counter -->
      <div class="controls-box">
        <!-- Control Buttons -->
        <div class="buttons">
          <!-- End call button -->
          <v-btn
            rounded
            height="50"
            width="150"
            style="min-width: 50px !important"
            class="red"
            @click="leaveCall()"
            ><v-icon>$CallEnd</v-icon></v-btn
          >
        </div>
      </div>
    </div>
    <div v-show="!connecting">
      <!-- Display contact gravatar and name -->
      <Transition name="fade" mode="out-in">
        <div class="contact-info" v-if="showControls">
          <div class="me-2 mb-3 d-flex">
            <div v-if="loaded">
              <v-gravatar
                style="min-width: 30px"
                width="55"
                :email="userInfo.email"
                v-if="!userInfo.avatarUrl"
              />
              <img v-else :src="userInfo.avatarUrl" />
            </div>
            <span class="fs-medium white--text pa-5">
              {{ userInfo.userName }}
            </span>
          </div>
        </div>
      </Transition>

      <!-- Videos of both users in desktop screen -->
      <div v-if="deviceType == 'desktop'">
        <!-- The opposite person's video -->
        <div
          @click="selfBigger = false"
          :class="!selfBigger ? 'big-video' : 'small-video pointer'"
        >
          <video id="otherUserVideo"></video>
        </div>
        <!-- The person's own video -->
        <div
          v-show="selfScreen"
          @click="selfBigger = true"
          :class="selfBigger ? 'big-video' : 'small-video pointer'"
        >
          <video id="myVideo"></video>
        </div>
      </div>

      <!-- Videos of both users in ipad and mobile screen -->
      <div v-else>
        <!-- The opposite person's video -->
        <div
          @click="selfBigger = false"
          :class="
            !selfBigger
              ? 'big-video'
              : showControls
              ? 'small-video pointer'
              : 'down-small-video pointer'
          "
        >
          <video id="otherUserVideo"></video>
        </div>
        <!-- The person's own video -->
        <div
          @click="selfBigger = true"
          v-show="selfScreen"
          :class="
            selfBigger
              ? 'big-video'
              : showControls
              ? 'small-video pointer'
              : 'down-small-video pointer'
          "
        >
          <video id="myVideo"></video>
        </div>
      </div>

      <!-- Video call control buttons and call time counter -->
      <Transition name="fade" mode="out-in">
        <div class="controls-box" v-if="showControls">
          <!-- Call time counter -->
          <div class="video-time fs-small">{{ toHHMMSS(callDuration) }}</div>
          <!-- Control Buttons -->
          <div class="buttons">
            <!-- End call button -->
            <v-btn
              rounded
              height="50"
              width="51"
              style="min-width: 50px !important"
              class="red mx-3"
              @click="leaveCall()"
              ><v-icon>$CallEnd</v-icon></v-btn
            >

            <!-- The person's own video display button -->
            <v-btn
              rounded
              height="50"
              width="50"
              style="
                min-width: 50px !important;
                backdrop-filter: blur(20px) saturate(120%) contrast(200%);
              "
              class="mx-3"
              @click="
                selfScreen = !selfScreen;
                selfBigger = false;
              "
            >
              <v-icon v-if="!selfScreen">$ScreenOn</v-icon>
              <v-icon v-else>$ScreenOff</v-icon></v-btn
            >

            <!-- The button to open users chat in new tab -->
            <v-btn
              rounded
              height="50"
              width="50"
              style="min-width: 50px !important"
              class="mx-3"
              @click="goToChat()"
              ><v-icon>$Chat</v-icon></v-btn
            >

            <!-- The button to ON or Off own voice -->
            <!-- <v-btn
              rounded
              height="50"
              width="50"
              style="min-width: 50px !important"
              class="black-icon mx-2"
              @click="toggleAudio()"
            >
              <v-icon v-if="!voice">$Voice</v-icon>
              <v-icon v-else>$VoiceOff</v-icon></v-btn
            > -->

            <!-- The button to ON or Off own video -->
            <!-- <v-btn
              rounded
              height="50"
              width="50"
              style="min-width: 50px !important"
              class="mx-2"
              @click="toggleVideo()"
            >
              <v-icon v-if="!video">$VideoCall</v-icon>
              <v-icon v-else>$VideoOff</v-icon>
            </v-btn> -->
          </div>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import socketConnection from "./../../socketConnection";

export default {
  data() {
    return {
      userId: "",
      ROOM_ID: "",
      interval: "",
      chatUserId: "",
      deviceType: "",
      userInfo: {
        userName: "",
        email: "",
        avatarUrl: "",
      },
      video: true,
      voice: true,
      loading: true,
      otherUser: {},
      connecting: true,
      selfScreen: true,
      selfBigger: false,
      showControls: true,
      userWaiting: true,
      callDuration: 0,
      loaded: false,
      role: "",
    };
  },
  methods: {
    // the function to show and hide elements by moving the mouse in video call
    controlsDisplay() {
      this.showControls = true;
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.showControls = false;
      }, 5000);
    },
    // the function to count call time
    counter() {
      setTimeout(() => {
        this.callDuration++;
        this.counter();
      }, 1000);
    },
    // the function to determine the order of hours, minutes and seconds
    toHHMMSS(value) {
      var sec_num = parseInt(value, 10); // don't forget the second param
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - hours * 3600) / 60);
      var seconds = sec_num - hours * 3600 - minutes * 60;

      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return minutes + ":" + seconds;
    },
    goToChat() {
      let link = "/chat/" + this.$route.params.id;
      window.open(link, "_blank");
    },
    leaveCall() {
      if (!this.connecting) {
        this.stop("#otherUserVideo");
      }
      window.close();
    },
    join() {
      this.connecting = false;
      this.counter();
      socketConnection.emit("enterCall", this.ROOM_ID);
    },

    // // the function to ON or OFF own video
    // toggleVideo() {
    //   const video1 = document.querySelector("#myVideo");
    //   video1.srcObject.getVideoTracks()[0].enable = !this.video;
    //   this.video = !this.video;
    // },
    // // the function to ON or OFF own audio
    // toggleAudio() {
    //   const video1 = document.querySelector("#myVideo");
    //   video1.srcObject.getAudioTracks()[0].enable = !this.voice;
    //   this.voice = !this.voice;
    // },

    // the function to stop own or other's video
    stop(id) {
      const video1 = document.querySelector(id);
      if (video1 && video1.srcObject) {
        video1.srcObject.getAudioTracks()[0].stop();
        video1.srcObject.getVideoTracks()[0].stop();
      }
    },
    getInfo() {
      this.loading = true;
      Axios.get(
        this.baseUrl +
          "/ppkpms" +
          (this.role == "contact" ? "/contact" : "") +
          "/chat/userInfo/" +
          this.$route.params.id,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )

        .then((res) => {
          if (res.status == 200) {
            this.otherUser = res.data;
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast("Error: " + err.response.data, "error");
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    next();
    if (from.path.toLowerCase().includes("videocall")) {
      this.connecting = false;
    }
  },
  beforeRouteLeave(to, from, next) {
    socketConnection.emit("leaveCall", {
      roomId: this.ROOM_ID,
      userId: this.userId,
      chatUserId: this.chatUserId,
    });
    this.stop("#myVideo");

    next();
  },
  mounted() {
    this.loaded = false;
    this.role = localStorage.getItem("role");
    this.controlsDisplay();
    this.ROOM_ID = this.$route.params.id;
    let roomId = this.$route.params.id;
    this.getInfo();

    // const videoGrid = document.querySelector("#video-grid");
    const myPeer = new Peer(undefined, {
      host: "peerjs.satrapp.com",
    });
    const video1 = document.querySelector("#myVideo");
    video1.setAttribute("autoplay", true);
    video1.muted = true;
    video1.setAttribute("playsinline", true);
    const peers = [];
    let counter = 0;

    // Get the user main id
    this.userId = localStorage.getItem("userId");
    // Get the user id in CHAT ROOM
    this.chatUserId = localStorage.getItem("chatUserId");

    if (window.screen.width < 1264) {
      this.deviceType = "mobile";
    } else {
      this.deviceType = "desktop";
    }

    socketConnection.emit("join-room", {
      roomId: this.ROOM_ID,
      userId: this.userId,
      chatUserId: this.chatUserId,
    });

    navigator.mediaDevices
      .getUserMedia({
        video: {
          facingMode: "user",
        },
        audio: true,
      })
      .then((stream) => {
        this.getInfo();
        addVideoStream(video1, stream, "");
        setTimeout(() => {
          myPeer.on("call", (call) => {
            call.answer(stream);
            const video2 = document.querySelector("#otherUserVideo");
            video2.setAttribute("autoplay", true);
            video2.setAttribute("playsinline", true);

            call.on("stream", (userVideoStream) => {
              socketConnection.on("showVideo", (userId) => {
                addVideoStream(video2, userVideoStream, userId);

                if (video2.srcObject != null && counter == 0) {
                  socketConnection.emit("enterCall", roomId);
                  counter++;
                }
              });
              socketConnection.emit("isReady", roomId);
            });
          });
          socketConnection.on("user-connected", (userId) => {
            connectToNewUser(userId, stream);
            setTimeout(() => {
              if (this.userWaiting) {
                window.location.reload();
              }
            }, 3000);
          });
        }, 200);
      });

    socketConnection.on("user-disconnected", (userId) => {
      if (peers[userId]) peers[userId].close();
      this.stop("#otherUserVideo");
    });

    myPeer.on("open", (id) => {
      socketConnection.emit("join-room", {
        roomId: this.ROOM_ID,
        userId: id,
        chatUserId: this.chatUserId,
      });
    });
    function connectToNewUser(userId, stream) {
      const call = myPeer.call(userId, stream);
      const video2 = document.querySelector("#otherUserVideo");

      call.on("stream", (userVideoStream) => {
        socketConnection.on("showVideo", (userId) => {
          addVideoStream(video2, userVideoStream, userId);
          if (video2.srcObject != null && counter == 0) {
            socketConnection.emit("enterCall", roomId);
            counter++;
          }
        });
        socketConnection.emit("isReady", roomId);
      });
      call.on("close", () => {
        video2.srcObject = "";
      });

      peers[userId] = call;
    }

    function addVideoStream(video, stream, userId) {
      let connecting = document.querySelector(".connecting");
      if (
        !userId ||
        (userId != localStorage.getItem("userId") &&
          connecting.style.display == "none")
      ) {
        video.srcObject = stream;
        video.addEventListener("loadedmetadata", () => {
          video.play();
        });
      }
    }

    function removeVideoStream(video) {
      video.srcObject = null;
    }

    socketConnection.on("userWaiting", () => {
      this.userWaiting = false;
    });

    // socketConnection.on("showVideo", (userId) => {
    //   console.log("showUserId: " + userId);
    //   console.log(this.userId);
    //   console.log("b: " + this.showVideo);
    //   if (userId != this.userId && !this.connecting) {
    //     this.showVideo = true;
    //   }
    //   console.log("a: " + this.showVideo);
    // });

    socketConnection.on("hideVideo", () => {
      this.userWaiting = true;
      this.connecting = true;
      const video2 = document.querySelector("#otherUserVideo");
      removeVideoStream(video2);
    });
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.video-call {
  max-height: 100vh;
  overflow: hidden;
  background-color: rgb(27, 27, 27);
  position: relative;

  .contact-info {
    position: absolute;
    top: 30px;
    right: 30px;
    z-index: 50;
    img {
      border-radius: 50px;
    }
    @media only screen and (min-width: 601px) and (max-width: 1300px) {
      right: 30px;
      top: 30px;
    }
    @media only screen and (max-width: 600px) {
      right: 20px;
      top: 20px;
    }
  }
  .big-video {
    width: 100vw;
    height: 100vh;
    transform: scaleX(-1);
  }
  .small-video {
    width: 19vw;
    height: 23vh;
    transform: scaleX(-1);
    border-radius: 10px;
    position: fixed;
    right: 30px;
    bottom: 25px;
    z-index: 55;
    border: 1px solid #3f3f3f;
    background-color: #202020;
    @media only screen and (max-width: 600px) {
      bottom: 100px;
      right: 20px;
      width: 27vw;
    }
    @media only screen and (min-width: 601px) and (max-width: 1300px) {
      bottom: 160px;
      right: 30px;
      width: 24vw;
    }
    video {
      border-radius: 10px;
    }
  }
  .down-small-video {
    height: 23vh;
    border-radius: 10px;
    position: fixed;
    transform: scaleX(-1);
    z-index: 55;
    border: 1px solid #3f3f3f;
    @media only screen and (max-width: 600px) {
      bottom: 20px;
      right: 20px;
      width: 27vw;
    }
    @media only screen and (min-width: 601px) and (max-width: 1300px) {
      bottom: 30px;
      right: 30px;
      width: 24vw;
    }
    video {
      border-radius: 10px;
    }
  }

  .controls-box {
    width: 100%;
    text-align: center;
    position: fixed;
    bottom: 75px;
    z-index: 50;
    @media only screen and (max-width: 700px) {
      bottom: 21px;
    }
    @media only screen and (min-width: 601px) and (max-width: 1300px) {
      bottom: 70px;
    }
    .video-time {
      background-color: rgba($color: #000000, $alpha: 0.4);
      color: #fff;
      width: fit-content;
      min-width: 75px;
      margin: 25px auto;
      padding: 5px 20px;
      border-radius: 50px;
    }
  }
}
#video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, 300px);
  grid-auto-rows: 300px;
}

video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.connecting {
  background-color: rgba($color: #000000, $alpha: 0.9);
  height: 100vh;
  text-align: center;
  position: relative;
  .userInfo {
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 180px;
      height: 180px;
      border-radius: 50%;
    }
  }
  .controls-box {
    width: 100%;
    text-align: center;
    position: fixed;
    bottom: 75px;
    z-index: 50;
    @media only screen and (max-width: 700px) {
      bottom: 30px;
    }
    @media only screen and (min-width: 601px) and (max-width: 1300px) {
      bottom: 70px;
    }
  }
}
</style>
